import type { FC } from "react";

import { ErrorWithContact } from "@components/errors/ErrorWithContact/ErrorWithContact";
import { RetryError } from "@components/errors/RetryError/RetryError";
import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { AccessErrorsProps } from "./AccessErrors.types";

export const AccessErrors: FC<AccessErrorsProps> = ({
  refetch,
  errorStatus,
  location,
  isSubmit,
}) => {
  const { t } = useCustomTranslation(["main", "common"]);

  switch (errorStatus) {
    case 403:
    case 400:
      return (
        <ErrorWithContact
          imageType="notFound"
          text={t("userErrors.contactEmail")}
          title={t(`userErrors.${location}`)}
        />
      );
    case 404:
      return (
        <ErrorTemplate
          data-testid="ErrorNotFound-container"
          imageType="errorFix"
          title={t("errors.notFound.title", { ns: "common" })}
        />
      );
    default:
      return (
        <RetryError
          isSubmit={isSubmit}
          onRetry={refetch}
          text=""
          title={t("errors.title.large", { ns: "common" })}
        />
      );
  }
};
